import { Button, Modal, List, ListItem, ListItemText, Avatar, LinearProgress } from '@mui/material';
import { useState, useEffect } from 'react';
import { DarkModeSwitch } from 'react-toggle-dark-mode';
import '../css/Settings.css'
import AddIcon from '@mui/icons-material/Add';
import Card from '@mui/material/Card';
import Chip from '@mui/material/Chip';
import Alert from '@mui/material/Alert';
import CardContent from '@mui/material/CardContent';
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';

function ThemeSelector({
    setColorTheme,
    colorTheme,
    theme,
    openTheme,
    display
}) {
    return(
        <>
        <div className='theme'>
                <div style={{display: 'flex', gap: 5, alignItems: 'center'}}>
                <h3>Nouvelle</h3>
                <Chip label="Default" variant="outlined" />
                </div>
                <p>The new DoNotes blue</p>
                
                {colorTheme === 'nouvelle' ? <Tooltip title="Select 'Nouvelle'" placement='right' arrow>
                    
                <md-filled-button onClick={() => { setColorTheme('nouvelle') }}>Selected</md-filled-button> 
                </Tooltip>: 
                <Tooltip title="Select 'Nouvelle'" placement='right' arrow>
                    
                <md-outlined-button onClick={() => { openTheme(); setColorTheme('nouvelle') }}>Select</md-outlined-button>
                </Tooltip>
                }
                </div>
                <div className='theme'>
                <div style={{display: 'flex', gap: 5, alignItems: 'center'}}>
                <h3 >Bojo Bloo </h3>
                </div>
                <p>The default DoNotes 'bloo' color scheme</p>
                {colorTheme === 'default' ? <Tooltip title="Select 'BoJo Blue'" placement='right' arrow>
                    
                <md-filled-button onClick={() => { setColorTheme('default') }}>Selected</md-filled-button> 
                </Tooltip>: 
                <Tooltip title="Select 'BoJo Blue'" placement='right' arrow>
                    
                <md-outlined-button onClick={() => { openTheme(); setColorTheme('default') }}>Select</md-outlined-button>
                </Tooltip>
                }
        </div>
        <div className='theme'>
                <h3>Groovilicious</h3>
                <p>DoNotes in a reimagined Groovy Orange</p>
                
                {colorTheme === 'groovilicious' ? <Tooltip title="Select 'Groovilicious'" placement='right' arrow>
                    
                <md-filled-button onClick={() => { setColorTheme('groovilicious') }}>Selected</md-filled-button> 
                </Tooltip>: 
                <Tooltip title="Select 'Groovilicious'" placement='right' arrow>
                    
                <md-outlined-button onClick={() => { openTheme(); setColorTheme('groovilicious') }}>Select</md-outlined-button>
                </Tooltip>
                }
                </div>
                
        <div className='theme'>
                <h3>Plain (Alpha)</h3>
                <p>Sleek, professional and simple</p>
                
                {colorTheme === 'plain' ? <Tooltip title="Select 'Plain'" placement='right' arrow>
                    
                <md-filled-button onClick={() => { setColorTheme('plain') }}>Selected</md-filled-button> 
                </Tooltip>: 
                <Tooltip title="Select 'Plain'" placement='right' arrow>
                    
                <md-outlined-button onClick={() => { openTheme(); setColorTheme('plain') }}>Select</md-outlined-button>
                </Tooltip>
                }
                </div>
        <div className='theme'>
                <h3>Foliage</h3>
                <p>A subtle greenness to encompass the foliage of the jungle</p>
                
                {colorTheme === 'foliage' ? <Tooltip title="Select 'Foliage'" placement='right' arrow>
                    
                <md-filled-button onClick={() => { setColorTheme('foliage') }}>Selected</md-filled-button> 
                </Tooltip>: 
                <Tooltip title="Select 'Foliage'" placement='right' arrow>
                    
                <md-outlined-button onClick={() => {openTheme();  setColorTheme('foliage') }}>Select</md-outlined-button>
                </Tooltip>
                }</div> 
        <div className='theme'>
                <h3>Panther</h3>
                <p>Prowl into the notes like a Pink Panther</p>
                {colorTheme === 'panther' ? <Tooltip title="Select 'Panther'" placement='right' arrow>
                    
                <md-filled-button onClick={() => { setColorTheme('panther') }}>Selected</md-filled-button> 
                </Tooltip>: 
                <Tooltip title="Select 'Panther'" placement='right' arrow>
                    
                <md-outlined-button onClick={() => { openTheme(); setColorTheme('panther') }}>Select</md-outlined-button>
                </Tooltip>
                }</div> 
        <div className='theme'>
            
        <h3>YoYo</h3>
                <p>The Electromagnetic spectral wavelength distribution and reflection characteristics of the Sun (viewed from Earth)</p>
                {colorTheme === 'yoyo' ? <Tooltip title="Select 'YoYo'" placement='right' arrow>
                    
                <md-filled-button onClick={() => { setColorTheme('yoyo') }}>Selected</md-filled-button> 
                </Tooltip>: 
                <Tooltip title="Select 'YoYo'" placement='right' arrow>
                    
                <md-outlined-button onClick={() => { openTheme(); setColorTheme('yoyo') }}>Select</md-outlined-button>
                </Tooltip>
                }</div> 
        </>
    )
}
export default function Settings({
    open,
    setOpen,
    colorScheme,
    setColorScheme,
    username,
    lowPower,
    setLowPower,
    theme,
    setColorTheme,
    mainVersion,
    colorTheme,
}) {
    function blank() {}
    const handleClose = () => {
        setOpen(false)
    }
    const [showThemeLoader, setShowThemeLoader] = useState(false);
    const [showDarkThemeLoader, setShowDarkThemeLoader] = useState(false);
    function openTheme() {
        
    setShowThemeLoader(true)
    const timer = setTimeout(()=>{
        setShowThemeLoader(false)
    }, 1000)
    return ()=>clearTimeout(timer)
    }
    function openDarkTheme() {
        
        setShowDarkThemeLoader(true)
    const timer = setTimeout(()=>{
        setShowDarkThemeLoader(false)
    }, 1000)
    return ()=>clearTimeout(timer)
    }
    const [selected, setSelected] = useState('account')
    const [profileEdit, setProfileEdit] = useState(false);
    const [newUsername, setNewUsername] = useState(username)
    function editProfile() {
        setProfileEdit(true)
    }
    function unEditProfile() {
        setProfileEdit(false)
    }
    function handleSave() {
        if(newUsername === null || newUsername === undefined || newUsername === '') {

        }else {
            //todo fix!
            /*
            const un = encrypt(newUsername, privateKey, publicKey)
            const message = {
                type: 'update-username',
                username: un,
                clientId,
            }
            sendMessage(JSON.stringify(message))
            */
            unEditProfile()
        }
    }    const currentYear = new Date().getFullYear();

    useEffect(()=>{
        setNewUsername(username)
    }, [username])
    const [isDarkMode, setIsDarkMode] = useState(false)
    useEffect(()=>{
        if(colorScheme === 'dark') {
            setIsDarkMode(true)
        }else {
            setIsDarkMode(false)
        }
    }, [colorScheme])
    useEffect(()=>{
        if(isDarkMode === true) {
            setColorScheme('dark')
        }else {
            setColorScheme('light')
        }
    }, [isDarkMode])

  const toggleDarkMode = (checked) => {
    setIsDarkMode(!checked)
  };

    return (
        <>
        
        <Modal open={open} onClose={handleClose}>
          <dn-modal class='modal-bg'>
            <div className='topBar' >
                <Tooltip title="Close Settings">
                    
              <md-icon-button onClick={handleClose}>
                  <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m313-440 224 224-57 56-320-320 320-320 57 56-224 224h487v80H313Z"/></svg>
              </md-icon-button>
                </Tooltip>
               <span style={{textTransform: 'capitalize'}}> 
               Settings | {selected}
              </span>
              
            </div>
            <dn-settings>
                <dn-settings-option>
                    <Tooltip title="Account Settings" placement="right" arrow>  
                        <md-filled-tonal-button class={selected === 'account' && 'selected'} onClick={()=>{setSelected('account')}}>
                            Account
                        </md-filled-tonal-button>
                    </Tooltip>
                    <Tooltip title="Security Settings" placement="right" arrow>
                        <md-filled-tonal-button class={selected === 'security' && 'selected'} onClick={()=>{setSelected('security')}}>
                            Security
                        </md-filled-tonal-button>
                    </Tooltip>
                    
                    <Tooltip title="Adjust appearance" placement="right" arrow>
                        <md-filled-tonal-button class={selected === 'themes' && 'selected'} onClick={()=>{setSelected('themes')}}>
                            Appearance
                        </md-filled-tonal-button>
                    </Tooltip>                    
                    <Tooltip title="Support tickets" placement="right" arrow>
                        <md-filled-tonal-button class={selected === 'support' && 'selected'} onClick={()=>{setSelected('support')}}>
                            Support
                        </md-filled-tonal-button>
                    </Tooltip>                    
                    <div className='error-btn' style={{marginTop: 'auto'}}>
                        <Tooltip title="Request account deletion" placement="right" arrow>
                                <md-filled-button class={selected === 'delete' && 'selected' } onClick={()=>{setSelected('delete')}}>
                                Delete Account
                                </md-filled-button>
                        </Tooltip>
                    </div>
                </dn-settings-option>
                
            {/**Account (Uneditable)*/}
            {selected === 'account' && profileEdit === false &&
            <dn-page>
            <h2>Account</h2>
            <Alert severity='warning'>Account customizability is not finished</Alert>
            <dn-page-section>
                <h3 style={{display: 'flex', alignItems: 'center', gap: 10, paddingBottom: 5}}>Public details 
                <Tooltip title="Edit Public Info" arrow placement='right'>
                    <md-text-button onClick={editProfile}>
                        <svg slot="icon" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z"/></svg>
                        Edit
                    </md-text-button>
                </Tooltip>
                </h3>
                <dn-user-info> 
                    <dn-user-hero>
                        <Avatar 
                        sx={{ width: 56, height: 56 }}>S</Avatar>
                        <dn-username>
                            {username}
                        </dn-username>
                    </dn-user-hero>
                    <dn-user-content>
                        <h3>Catchphrase</h3>
                        <p>Reach for the sky</p>
                    </dn-user-content>
                    <dn-user-content>
                        <h3>Bio</h3>
                        <p>Lorum Ipsum</p>
                    </dn-user-content>
                </dn-user-info>
            </dn-page-section>
            <dn-page-section>
                <h3>Personal data</h3>
                Your e-mail: <b>someone@example.com</b>
            </dn-page-section>
            <img src="https://donotes.app/logo5.svg" width="50"/>
            DoNotes &copy; {currentYear} | {mainVersion} <a href="https://donotes.app/terms">Terms & Conditions</a> <a href="https://donotes.app/privacy">Privacy Policy</a>
            
        </dn-page>
            
            }
            {/**Account Editable */}
            {selected === 'account' && profileEdit === true &&
            <dn-page>
            <h2>Account</h2>
            <Alert severity='warning'>Account customizability is not finished</Alert>
            <dn-page-section>
                <h3 style={{display: 'flex', alignItems: 'center', gap: 10, paddingBottom: 5}}>Public details 
                <Tooltip title="Edit Public Info" arrow placement='right'>
                    <md-filled-tonal-button onClick={handleSave} style={{width: 'fit-content'}}>
                        
                        <svg slot="icon" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M840-680v480q0 33-23.5 56.5T760-120H200q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h480l160 160Zm-80 34L646-760H200v560h560v-446ZM480-240q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35ZM240-560h360v-160H240v160Zm-40-86v446-560 114Z"/></svg>
                        Save
                    </md-filled-tonal-button>
                </Tooltip>
                </h3>
                <dn-user-info> 
                    <dn-user-hero>
                        <Avatar 
                        sx={{ width: 56, height: 56 }}>S</Avatar>
                        <TextField 
                            required
                            id="outlined-required"
                            label="Username"
                            value={newUsername}
                            onChange={(e)=>{setNewUsername(e.target.value)}}
                        />
                    </dn-user-hero>
                    <dn-user-content>
                        <h3>Catchphrase</h3>
                        <p>Reach for the sky</p>
                    </dn-user-content>
                    <dn-user-content>
                        <h3>Bio</h3>
                        <p>Lorum Ipsum</p>
                    </dn-user-content>
                </dn-user-info>
            </dn-page-section>
            <dn-page-section>
                <h3>Personal data</h3>
                Your e-mail: <b>someone@example.com</b>
            </dn-page-section>
            <img src="https://donotes.app/logo5.svg" width="50"/>
            DoNotes &copy; {currentYear} | v8 {mainVersion} <a href="https://donotes.app/terms">Terms & Conditions</a> <a href="https://donotes.app/privacy">Privacy Policy</a>
            
        </dn-page>
            
            }
            {/**Security */}
            {selected === 'security' && 
            <dn-page>
                <h2>Security</h2>
                <Alert severity='warning'>2FA is not finished</Alert>
                <dn-page-section>
                    <h3>Enable 2-factor authentication</h3>

                </dn-page-section>
            <img src="https://donotes.app/logo5.svg" width="50"/>
            DoNotes &copy; {currentYear} | v8 {mainVersion} <a href="https://donotes.app/terms">Terms & Conditions</a> <a href="https://donotes.app/privacy">Privacy Policy</a>
            
            </dn-page>
            }
            {/**Themes */}
            {selected === 'themes' && 
            <dn-page>
                <h2>Appearance</h2>
                <dn-page-section>
                    
                    <h3>Toggles</h3>
                    <div style={{display: 'flex', gap: 10}}>
                        
                    <Tooltip title="Toggle dark mode (This will auto-update with your system color scheme)" arrow placement='bottom'>
                    <md-outlined-button onClick={()=>{openDarkTheme();toggleDarkMode(isDarkMode)}}>
                        <DarkModeSwitch
                        checked={!isDarkMode}
                        moonColor='black'
                        onChange={()=>{blank()}}
                        sunColor='white'
                        size={25}
                        slot="icon"
                        />
                        {
                            isDarkMode ? 'Enable light   mode' : 'Enable dark mode'
                        }
                        </md-outlined-button>
                </Tooltip>
                <Tooltip title="Toggle Animations (turns off most animations)" arrow placement='bottom'>
                    <md-outlined-button onClick={()=>{setLowPower(!lowPower)}}>
                        {!lowPower ? 'Disable animations' : 'Enable animations'}
                        </md-outlined-button>
                </Tooltip>
                    </div>
                </dn-page-section>
                <dn-page-section>
                    <h3>Themes</h3>
                    <br />
                <ThemeSelector  openTheme={openTheme} theme={theme} colorTheme={colorTheme} setColorTheme={setColorTheme} display={'flex'} />
                </dn-page-section>
            <img src="https://donotes.app/logo5.svg" width="50"/>
            DoNotes &copy; {currentYear} | v8 {mainVersion} <a href="https://donotes.app/terms">Terms & Conditions</a> <a href="https://donotes.app/privacy">Privacy Policy</a>
            
            </dn-page>
            }
            {/**Support */}
            {selected === 'support' && 
            <dn-page>
                <h2>Support</h2>
                
                <Alert severity='warning'>Account support is not finished</Alert>
                <div className='tonal'>
                <Tooltip title="Create support ticket" placement='right' arrow>
                    
                <md-filled-button disabled>
                <AddIcon
                    slot="icon"/>
                    Open support ticket
                </md-filled-button>
                </Tooltip>
                </div>
                <dn-page-section>
                    <h3>Your support tickets</h3>
                    No tickets opened
                </dn-page-section>
            <img src="https://donotes.app/logo5.svg" width="50"/>
            DoNotes &copy; {currentYear} | v8 {mainVersion} <a href="https://donotes.app/terms">Terms & Conditions</a> <a href="https://donotes.app/privacy">Privacy Policy</a>
            
            </dn-page>
            }
            {/**Delete */}
            {selected === 'delete' && 
            <dn-page>
                <h2 className='delete-txt'>Delete account</h2>
                
                <Alert severity='warning'>Account deletion is not finished</Alert>
                <dn-page-section>
                    <div className='error-btn'>
                        
                    <md-filled-button disabled>
                        Close my account 
                    </md-filled-button>
                    </div>
                </dn-page-section>
            <img src="https://donotes.app/logo5.svg" width="50"/>
            DoNotes &copy; {currentYear} | v8 {mainVersion} <a href="https://donotes.app/terms">Terms & Conditions</a> <a href="https://donotes.app/privacy">Privacy Policy</a>
            </dn-page>
            }
            </dn-settings>
          </dn-modal>
        </Modal>
        {showThemeLoader && 
        <div class="loading-overlay">
            Loading '{colorTheme}'...
            <div style={{
                width: 300,
                height: 20,
                marginTOp: 100
            }}>
                
            <LinearProgress />
            </div>
        </div>}
        {showDarkThemeLoader && 
        <div class="loading-overlay">
            Switching theme...
            <div style={{
                width: 300,
                height: 20,
                marginTOp: 100
            }}>
                
            <LinearProgress />
            </div>
        </div>}
        </>
      );
}